import { Injectable } from "@angular/core";

import { AlternativeCropSearchCriteria } from "@models/AlternativeCropSearchCriteria";

import { PlantsService } from "./plants.service";

@Injectable()
export class AlternativeCropSearchResolver {
  constructor(private ps: PlantsService) {}

  async resolve(): Promise<AlternativeCropSearchCriteria> {
    const criteria = await this.ps.getAlternativeCropSearchCriteria();
    return criteria;
  }
}
